import { FlexibleTableHeaderColumn } from "src/shared/components/data-display/FlexibleTable/flexible-table-items.interface";

export const HEADERS: FlexibleTableHeaderColumn[] = [
    {
        value: "#"
    },
    {
        value: "Categoría"
    },
    {
        value: "Producto"
    },
    {
        value: "Cantidad"
    },
    {
        value: "Precio"
    },
    {
        value: "Comentarios"
    },
    {
        value: "Eliminar"
    },
]